export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-14.jpg'),
        title: 'ENTERPRISE MOBILITY',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'HIGH-EFFICIENCY OFFICE ENVIRONMENT, COST SAVING AND INTEGRATED RESOURCE.',
      description: `<p style="font-size:1.5rem">
      With the development of modern social science and technology, as well as the rapid popularization of the Internet industry, the demand for mobile office and channel emerges are required. OA system, ERP system, e-mail system and CRM system have become indispensable tools for work. Enterprises has insufficient ability to develop apps independently, due to a lot of investment and time cost. This problem can be effectively solved by outsourcing business. Maesinfo has 12 years of services experience in enterprise-level application and operation, helping more than 40 countries customers to solve the problems of mobile office, helping them to work efficiently, save costs, and integrate internal resources. In addition, make ensure the safety of mobile, so that employees can use any equipment at any place to work in their own way.
      </p><p>We make sure : has adhering to the ‘customer first service philosophy, dedicated customer service. The core
competitiveness of the business, grasp the new model of mobile marketing, the accuracy
of identity recognition to ensure enterprise security,
the perfect combination of mobile phone and PC.</p>`
    },
    {
      title: 'WE CAN PROVIDE:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-14.jpg')+`)"></span>
      <span class="list">
      <i></i>OA system, ERP system, CRM system service<br/>
      <i></i>Customize mobile office systems and operation and maintenance services that meet the internal needs of enterprises for each enterprise.


      </span>`
    }
  ]
}
